<template>
	<div id="usuario-cuenta-suscripciones">

		<b-spinner v-if="isLoading" label="isLoading..."></b-spinner>

		<b-jumbotron v-if="suscripciones.length === 0" header="No tienes suscripciones activas"
			lead="Por favor, contrata una nueva suscripción para comenzar.">
			<b-button variant="primary" class="mt-3" @click="$router.push('/' + contrataYaURI)">
				{{ generalTitle }}
			</b-button>
		</b-jumbotron>

		<template v-else>
			<b-card class="mb-3 p-2" no-body>
				<div class="flex">
					<b-button-group size="xs">
						<b-button variant="primary" @click="$router.push('/' + contrataYaURI)">
							{{ generalTitle }}
						</b-button>
					</b-button-group>
				</div>
			</b-card>

			<filters-handler class="filters-handler" v-model="filterCfg" :items-count="cSuscriptionsFiltered.length"
				:per-page="perPage" />

			<div class="suscription-list">
				<div class="suscription card bg-dark highlightOnHover" 
					v-for="suscripcion in cSuscriptionsFiltered" 
					:key="'susc-' + suscripcion.id" 
					@click="$refs.suscripcionesMonitor.open(suscripcion.id)">
					<div class="plan-holder">
						<div class="plan-name">
							{{ suscripcion.planName }} 
							<!-- {{suscripcion.renovacion}} -->
							<div class="b-pill inline">{{ suscripcion.estatus | suscriptionStatusLabel }}</div>
						</div>
						<template v-if="suscripcion.estatus != 'Nueva'">
							<div class="b-pill active" v-if="parseInt(suscripcion.renovacion)">Renovación activa</div>
							<div class="b-pill" v-else>Renovación cancelada</div>
						</template>
					</div>
					<div class="created">{{ suscripcion.created | humanizar_fecha }}</div>
					<div class="stripe-suscripcion-id">Código: <span>{{ suscripcion.stripe_suscripcion_id }}</span></div>
				</div>
			</div>

		</template>


		<suscripciones-monitor ref="suscripcionesMonitor" @forceReload="forceReload"/>
	</div>
</template>

<script>
import _ from 'lodash'
import axios from 'axios'
import filtersHandler from '../daniel/filtersHandler.vue';
import contrataYa from '@@/contrata-ya/contrataYa.js'
import suscripcionesMonitor from '../daniel/suscripciones/suscripciones-monitor.vue';
import { notify } from '@/js/utils.js'

const bTable = 'bTable',
	toggleList = 'toggleList';

let formArchetype = {
	msisdn: null,
	id: null,
	pin: null
}

export default {
	components: {
		suscripcionesMonitor,
		filtersHandler
	},
	props: {

		indexMine: {
			type: String,
			default: 'suscripcion/indexMine'
		},

		generalTitle: {
			type: String,
			default: contrataYa.generalTitle
		},

		contrataYaURI: {
			type: String,
			default: contrataYa.URI
		},

		perPage: {
			type: Number,
			default: 5
		},

		fieldsProp: {
			type: Array,
			default: () => {
				return [
					'alias',
					{ key: 'msisdn', label: 'Número' },
					{ key: 'planName', label: 'Plan' },
					'precio',
					{ key: 'estatus_suscripcion', label: 'Suscripción' }
				]
			}
		}
		
	},
	data: () => {
		return {
			selectedItem: null,
			isLoading: false,
			isProcessing: false,
			showingAddingModal: false,
			suscripciones: [],
			filterCfg: {
				term: '',
				page: 1,
				args: {}
			},
			bTable,
			toggleList
		}
	},
	computed: {
		cNumerosPaginated() {
			const start = (this.filterCfg.page - 1) * this.perPage;
			const end = start + this.perPage;
			return this.cSuscriptionsFiltered.slice(start, end);
		},
		cSuscriptionsFiltered() {
			return this.suscripciones.filter(item => {
				if (!this.filterCfg.term) return true;
				const term = this.filterCfg.term.toLowerCase();
				return (
					(item.planName && item.planName.toLowerCase().includes(term)) ||
					(item.estatus && item.estatus.toLowerCase().includes(term)) ||
					(item.created && item.created.toLowerCase().includes(term)) ||
					(item.stripe_suscripcion_id && item.stripe_suscripcion_id.toLowerCase().includes(term))
				);
			});
		}
	},
	methods: {
		async loadUp() {
			try {
				const response = await axios.get(this.indexMine)

				// procesa el objeto de respuesta
				if (!_.isObjectLike(response))
					throw 'Ocurrió un error en la respuesta';
				else if (response.status) {
					this.suscripciones = response.data.suscriptions || [];
				} else {
					this.suscripciones = [];
				}

				// devuelve el mensaje correcto, si se requiere
				if (response.msg)
					notify(response.msg, response.class)

			} catch (e) {
				notify(e)
			} finally {
				this.isLoading = false;
			}
		},
		async forceReload() {
			this.isLoading = true;
			await this.loadUp();
			if(this.$route.params.suscId)
				this.$nextTick(()=>{
					this.$refs.suscripcionesMonitor.open(this.$route.params.suscId)
				})
		}
	},
	async beforeMount() {
		await this.forceReload()
	}
}
</script>

<style lang="scss">
@import '../../../../sass/utils/_variables.scss';

#usuario-cuenta-suscripciones {

	
	.suscription {
		user-select: none;
		padding: 0.5em;
		cursor: pointer;
		// }
		.plan-holder {
			font-size: 1.25rem;
			display: flex;
			flex-flow: row;
			align-items: center;
  			justify-content: center;

			.plan-name {
				flex: 1 1 auto;
				display: block;
				font-weight: bold;
				color: $accent;
				// font-size: calc(1em / 1.618);
			}

		}
		&-list {
			// background-color: rgb(121, 27, 27);
			// color: black;
			margin: 1em 0;
			display: flex;
			flex-flow: column;
			gap: 0.5em;
		}
		.estatus {
			display: block;
			display: none;
			font-size: calc(1em / 1);
		}

	}

	.flex {
		display: flex;
		flex-flow: row nowrap;
		gap: 1em;
		align-items: center;
		justify-content: center;
		justify-content: end
	}

	.uppercase {
		text-transform: uppercase;
	}

	.unsuscribed {
		color: $accent;
		color: $secondary;
		text-transform: uppercase;
		font-weight: bold;
		font-weight: 0.8em;
	}

	tr {
		cursor: pointer;

		td {
			line-height: 1.0em;
		}
	}

	small {
		font-size: 0.5em;
		color: $accent-dark;
	}

	strong {
		color: $accent;
		font-size: 1.2em;
	}

	.btn.toggler.btn-black {
		background-color: $black;
		color: $accent;
	}

	.filters-handler {
		margin: 0;
	}
}
</style>